var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLeftJoystickDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    t: 1719108099766,
    className: "icon",
    viewBox: "0 0 1024 1024",
    xmlns: "http://www.w3.org/2000/svg",
    "p-id": 58053,
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 16,
    height: 16,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M427.446857 111.067429l66.56 88.722285c9.325714 12.544 26.331429 12.214857 35.364572 0l66.852571-88.722285c13.824-17.993143 6.4-41.142857-18.029714-41.142858h-133.046857c-23.478857 0-31.817143 22.491429-17.700572 41.142858z m84.224 569.270857c207.981714 0 341.028571-92.269714 341.028572-221.147429 0-128.914286-133.376-221.147429-341.357715-221.147428-207.323429 0-340.370286 92.233143-340.370285 221.147428 0 128.877714 133.046857 221.110857 340.699428 221.110857z m0-64.621715c-162.304 0-271.286857-63.305143-271.286857-156.525714 0-93.257143 108.982857-156.525714 270.994286-156.525714 162.633143 0 271.908571 63.268571 271.908571 156.525714 0 93.220571-108.982857 156.525714-271.616 156.525714z m-42.422857-56.576h97.060571c14.811429 0 24.429714-9.325714 24.429715-23.149714 0-14.116571-9.618286-23.149714-24.429715-23.149714h-69.412571v-135.606857c0-18.651429-10.605714-30.244571-27.648-30.244572-16.713143 0-27.648 11.593143-27.648 30.244572v151.698285c0 18.285714 10.605714 30.208 27.648 30.208z m42.422857 265.508572c83.273143 0 133.741714-38.912 133.741714-105.106286v-10.934857a621.238857 621.238857 0 0 1-133.741714 13.824c-47.908571 0-92.562286-4.827429-133.376-13.824v10.934857c0 66.194286 50.468571 105.106286 133.376 105.106286z",
    fill: "#333",
    "p-id": 58054
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeftJoystickDown);
export default __webpack_public_path__ + "static/media/left-joystick-down.b7e1c23a2641b5515d7608e0b5dc3b70.svg";
export { ForwardRef as ReactComponent };